import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Home, MapPin, Settings } from 'lucide-react';
import LocationScreen from './components/LocationScreen';
import LoginScreen from './components/LoginScreen';
import RegisterScreen from './components/RegisterScreen';
import SettingsScreen from './components/SettingsScreen';
import RidesScreen from './components/RidesScreen';
import ProblemStepsScreen from './components/ProblemStepsScreen';
import ProblemTypeScreen from './components/ProblemTypeScreen';
import AdditionalDetailsScreen from './components/AdditionalDetailsScreen';
import SearchScreen from './components/SearchScreen';
import TrackingScreen from './components/TrackingScreen';
import PaymentCardsScreen from './components/PaymentCardsScreen';
import PersonalInfoEditScreen from './components/PersonalInfoEditScreen';
import NetworkScreen from './components/ad/NetworkScreen';
import DeleteAccountScreen from './components/DeleteAccountScreen';
import ServiceDashboard from './components/service/dashboard';


// Componenta pentru Bottom Navigation
const BottomNavbar = () => {
  const location = useLocation();

  // Exclude navbar from auth screens
  if (['/login', '/register', '/details', '/problem-type', '/additional-details', '/search','/tracking', '/1','/2', '/intro','/personal-info-edit', '/dashboard'].includes(location.pathname)) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 pb-safe">
      <div className="flex justify-around items-center">
        <Link
          to="/"
          className={`flex flex-col items-center py-3 px-6 ${
            location.pathname === '/' ? 'text-blue-600' : 'text-gray-600'
          }`}
        >
          <Home className="w-6 h-6" />
          <span className="text-xs mt-1">Dashboard</span>
        </Link>

        <Link
          to="/rides"
          className={`flex flex-col items-center py-3 px-6 ${
            location.pathname === '/rides' ? 'text-blue-600' : 'text-gray-600'
          }`}
        >
          <MapPin className="w-6 h-6" />
          <span className="text-xs mt-1">Istoric Solicitari</span>
        </Link>

        <Link
          to="/settings"
          className={`flex flex-col items-center py-3 px-6 ${
            location.pathname === '/settings' ? 'text-blue-600' : 'text-gray-600'
          }`}
        >
          <Settings className="w-6 h-6" />
          <span className="text-xs mt-1">Setări</span>
        </Link>
      </div>
    </div>
  );
};

// Main App Layout
const AppLayout = ({ children }) => {
  const location = useLocation();
  const showNavbar = !['/login', '/register'].includes(location.pathname);

  return (
    <div className={`min-h-screen bg-gray-50 ${showNavbar ? 'pb-16' : ''}`}>
      {children}
      <BottomNavbar />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppLayout>
        <Routes>
          <Route path="/" element={<LocationScreen />} />
          <Route path="/rides" element={<RidesScreen />} />
          <Route path="/settings" element={<SettingsScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/register" element={<RegisterScreen />} />
          <Route path="/settings" element={<SettingsScreen />} />
          <Route path="/curse" element={<RidesScreen />} />
          <Route path="/details" element={<ProblemStepsScreen />} />
          <Route path="/problem-type" element={<ProblemTypeScreen />} />
          <Route path="/additional-details" element={<AdditionalDetailsScreen />} />
          <Route path="/search" element={<SearchScreen />} />
          <Route path="/tracking" element={<TrackingScreen />} />
          <Route path="/cards" element={<PaymentCardsScreen />} />
          <Route path="/intro" element={<NetworkScreen />} />
          <Route path="/personal-info-edit" element={<PersonalInfoEditScreen />} />
          <Route path="/delete-account" element={<DeleteAccountScreen />} />
          <Route path="/dashboard" element={<ServiceDashboard />} />
        </Routes>
      </AppLayout>
    </Router>
  );
}

export default App;